/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Access_UntilInputs */

const en_plan_access_until = /** @type {(inputs: Plan_Access_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access until`)
};

const es_plan_access_until = /** @type {(inputs: Plan_Access_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso hasta`)
};

/**
* | output |
* | --- |
* | "Access until" |
*
* @param {Plan_Access_UntilInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_access_until = /** @type {((inputs?: Plan_Access_UntilInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Access_UntilInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_access_until(inputs)
	return en_plan_access_until(inputs)
});